import '@fontsource-variable/archivo/wght.css';
import '@fontsource-variable/source-sans-3/wght.css';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';

import { createQueryClient } from '@/app/queryClient';
import { MotionProvider } from '@/components/atoms';
import { theme } from '@/theme';

export function AppProviders({ children }: { children: ReactNode }) {
  // One client per app instance, so build-time rendering never shares a cache.
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme} defaultMode="light">
        <CssBaseline enableColorScheme />
        <MotionProvider>{children}</MotionProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
